import React, { useEffect, useState } from "react";
import Button from "../../../components/Buttons/Button";
import DataTable from '../../../components/DataTable/DataTable';
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import DataService from "../../../services/data.service";

interface IProps {
    show: boolean
    onHide: () => void
    itemId: number
    itemRevisionId: number
}

const UsedInItemsPopup: React.FC<IProps> = ({ show, onHide, itemId, itemRevisionId }) => {
    const [data, setData] = useState<any[]>();
    const { handleException } = useNotifications();

    useEffect(() => {
        getTableData();
    }, [itemRevisionId]);

    function getTableData() {
        DataService.get<any[]>('api/v1/BillOfMaterialItems/ByItemRevision/' + itemId + '/' + itemRevisionId)
            .then(response => {
                setData(response);
                console.log(response)
            })
            .catch(e => { handleException(e); });
    }

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'The following items are using this item as part of their bill-of-materials'} >
            <Popup.Body>
                <DataTable
                    name='dtUsedInItems'
                    tableData={data}
                    navigateTitle='ItemRevision'
                    navigateUrl='/plm/Items/ItemRevision/'
                    colInfos={[
                        { key: true, dataProp: 'billOfMaterial.itemRevisionId', visible: false },
                        { title: 'Item', dataProp: 'billOfMaterial.itemRevision', dataType: 'itemrevision', sort: 'desc' }
                    ]}
                />
            </Popup.Body>
            <Popup.Footer>
                <Button onClick={onHide} text='Close' fill />
            </Popup.Footer>
        </Popup>
    );
}
export default UsedInItemsPopup;